import { render, staticRenderFns } from "./scoreList.vue?vue&type=template&id=0aa3f376&scoped=true"
import script from "./scoreList.vue?vue&type=script&lang=js"
export * from "./scoreList.vue?vue&type=script&lang=js"
import style0 from "./scoreList.vue?vue&type=style&index=0&id=0aa3f376&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3f376",
  null
  
)

export default component.exports